import React from 'react';

const LinkIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M16 11V17C16 17.5304 15.7893 18.0391 15.4142 18.4142C15.0391 18.7893 14.5304 19 14 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4H9M13 1H19V7M8 12L19 1" stroke="url(#paint0_radial_2943_4613)" fill="transparent" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <defs>
      <radialGradient id="paint0_radial_2943_4613" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-2.51 12.4425) rotate(-5.74518) scale(29.669)">
        <stop stopColor="#8098F9"/>
        <stop offset="0.49" stopColor="#C4BFF1"/>
        <stop offset="1" stopColor="#8098F9"/>
      </radialGradient>
    </defs>
  </svg>
);

export default LinkIcon;
